!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.trigger = null, this.nativeSelect = null, this.dropdown = null, this.options = [], 
      this.isOpen = !1, this.focusIndex = -1, this._uniqueId = "";
    }
    connectedCallback() {
      this.trigger = this.querySelector("[data-select-trigger]"), this.nativeSelect = this.querySelector("[data-native-select]"), 
      this.dropdown = this.querySelector("[data-dropdown]"), this.options = Array.from(this.querySelectorAll("[data-option]")), 
      this.trigger && this.nativeSelect && this.dropdown && (this._uniqueId = this.dataset.id || "select-default", 
      this.initAccessibility(), this.attachEventListeners(), this.updateSelectedState(this.nativeSelect.value));
    }
    initAccessibility() {
      this.trigger.setAttribute("role", "combobox"), this.trigger.setAttribute("aria-expanded", "false"), 
      this.trigger.setAttribute("aria-controls", `${this._uniqueId}-list`), this.trigger.setAttribute("aria-haspopup", "listbox"), 
      this.trigger.id = `${this._uniqueId}-button`, this.dropdown.id = `${this._uniqueId}-list`, 
      this.dropdown.setAttribute("role", "listbox"), this.dropdown.setAttribute("aria-labelledby", `${this._uniqueId}-button`), 
      this.options.forEach((t, e) => {
        t.id = `${this._uniqueId}-opt-${e}`, t.setAttribute("role", "option");
        const s = t.dataset.value === this.nativeSelect.value;
        t.setAttribute("aria-selected", s);
      });
    }
    attachEventListeners() {
      this.trigger.addEventListener("click", t => {
        t.preventDefault(), this.toggleDropdown();
      }), this.trigger.addEventListener("keydown", t => this.handleKeyDown(t)), this.options.forEach((t, e) => {
        t.addEventListener("click", s => {
          s.stopPropagation(), this.selectOption(t, e);
        });
      }), this.handleOutsideClick = t => {
        this.isOpen && !this.contains(t.target) && this.closeDropdown();
      }, document.addEventListener("click", this.handleOutsideClick), this.nativeSelect.addEventListener("change", () => {
        this.updateSelectedState(this.nativeSelect.value);
      });
    }
    handleKeyDown(t) {
      switch (t.key) {
       case "Enter":
       case " ":
        t.preventDefault(), this.isOpen ? this.focusIndex >= 0 && this.selectOption(this.options[this.focusIndex], this.focusIndex) : this.openDropdown();
        break;

       case "Escape":
        this.isOpen && (t.preventDefault(), this.closeDropdown());
        break;

       case "ArrowDown":
        t.preventDefault(), this.navigateOptions(1);
        break;

       case "ArrowUp":
        t.preventDefault(), this.navigateOptions(-1);
        break;

       case "Home":
        t.preventDefault(), this.focusIndex = 0, this.navigateOptions(0);
        break;

       case "End":
        t.preventDefault(), this.focusIndex = this.options.length - 1, this.navigateOptions(0);
      }
    }
    navigateOptions(t) {
      this.isOpen || this.openDropdown(), this.focusIndex += t, this.focusIndex < 0 && (this.focusIndex = 0), 
      this.focusIndex >= this.options.length && (this.focusIndex = this.options.length - 1), 
      this.updateVisualFocus();
      const e = this.options[this.focusIndex];
      e && e.scrollIntoView({
        block: "nearest"
      });
    }
    updateVisualFocus() {
      this.options.forEach((t, e) => {
        const s = t.querySelector("[data-indicator]"), i = "true" === t.dataset.selected, n = e === this.focusIndex;
        s && (i || n ? s.classList.add("outline-1", "outline-solid", "outline-scheme-text") : s.classList.remove("outline-1", "outline-solid", "outline-scheme-text")), 
        n && this.trigger.setAttribute("aria-activedescendant", t.id);
      });
    }
    toggleDropdown() {
      this.isOpen ? this.closeDropdown() : this.openDropdown();
    }
    openDropdown() {
      this.isOpen = !0, this.dropdown.classList.remove("hidden"), this.trigger.setAttribute("aria-expanded", "true"), 
      this.trigger.classList.add("text-scheme-links");
      const t = this.nativeSelect.value;
      this.focusIndex = this.options.findIndex(e => e.dataset.value === t), -1 === this.focusIndex && (this.focusIndex = 0), 
      this.updateVisualFocus();
      const e = this.trigger.querySelector("svg");
      e && e.classList.add("rotate-180");
    }
    closeDropdown() {
      this.isOpen = !1, this.dropdown.classList.add("hidden"), this.trigger.setAttribute("aria-expanded", "false"), 
      this.trigger.removeAttribute("aria-activedescendant"), this.trigger.classList.remove("text-scheme-links");
      const t = this.trigger.querySelector("svg");
      t && t.classList.remove("rotate-180"), this.trigger.focus();
    }
    selectOption(t, e) {
      const s = t.dataset.value;
      this.nativeSelect.value = s, this.nativeSelect.dispatchEvent(new Event("input", {
        bubbles: !0,
        cancelable: !0
      })), this.nativeSelect.dispatchEvent(new Event("change", {
        bubbles: !0,
        cancelable: !0
      })), this.updateSelectedState(s), this.closeDropdown();
    }
    updateSelectedState(t) {
      this.options.forEach(e => {
        const s = e.dataset.value === t, i = e.querySelector("[data-indicator]");
        e.dataset.selected = s, e.setAttribute("aria-selected", s), i && (s ? i.classList.add("bg-scheme-links") : i.classList.remove("bg-scheme-links"));
      });
    }
    disconnectedCallback() {
      document.removeEventListener("click", this.handleOutsideClick);
    }
  }
  customElements.get("custom-select") || customElements.define("custom-select", t);
}();